// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__i8U5q","overlay":"loader_overlay__9sOho","spinner":"loader_spinner__g2Hj1","spin":"loader_spin__VNcgK"};